/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchRequestModel } from '../../models/search-request-model';
import { SystemIdentifierRecordModelSearchResultModel } from '../../models/system-identifier-record-model-search-result-model';

export interface SystemIdentifierSearchSystemIdentifierPost$Params {
      body?: SearchRequestModel
}

export function systemIdentifierSearchSystemIdentifierPost(http: HttpClient, rootUrl: string, params?: SystemIdentifierSearchSystemIdentifierPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<SystemIdentifierRecordModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, systemIdentifierSearchSystemIdentifierPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<SystemIdentifierRecordModelSearchResultModel>;
    })
  );
}

systemIdentifierSearchSystemIdentifierPost.PATH = '/SystemIdentifier/SearchSystemIdentifier';
